
"use strict";

const bankStatementSummeryScript = function () {
    const dataTypes = {};
    const bankStatementDefaultConfig = {
        default_sort_by_header_config: {
            asc: 10,
            desc: 4
        },
        sort_by_header: {},
        all_multi_filter_types_order: {
            unit_level: {
                order: 1
            },
            amount_level: {
                order: 2
            }
        },
        exact_match_filter_options: [
            {
                key: 'transaction_type'
            },
            {
                key: 'group'
            },
            {
                key: 'classifications',
                header_key: 'category'
            },
            {
                key: 'account_level',
                header_key: 'account_number'
            }
        ],
        clicked_filters: {}
    };
    let promiseResolve;

    const widgetPromise = new Promise(function (resolve, reject) {
        promiseResolve = resolve;
    });

    /**
     * main : getting bank-statement html through config file
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param obj object
     */

    const main = (obj) => {
        Object.assign(bankStatementDefaultConfig, obj);
        bankStatementDefaultConfig.outlier_report_flag = false;
        const resource = [], temp_resource = bankStatementDefaultConfig.body.resource.split(',');
        let flag = false, is_data_found = false;
        bankStatementDefaultConfig.outlier_report_resource = 'account_level_monthly_activity';

        if (!temp_resource.length) {
            alert("At least one resource required.");
            return;
        }

        for (let i = 0; i < temp_resource.length; ++i) {
            const _resource = temp_resource[i].toString().trim();
            if (!bankStatementDefaultConfig.body.config[_resource]) continue;
            else is_data_found = is_data_found || bankStatementDefaultConfig.body.config[_resource].data !== undefined;
            if (_resource === bankStatementDefaultConfig.outlier_report_resource) flag = true;
            else resource.push(_resource);
            bankStatementDefaultConfig[_resource] = {
                multi_filter: initScript.hasObjectKeyProperty(bankStatementDefaultConfig.body.config[_resource], 'multiple')
            };
        }

        obj.body.resource = resource;
        bankStatementDefaultConfig.security_option = !!bankStatementDefaultConfig.body.security ? bankStatementDefaultConfig.body.security : {};
        obj.config = JSON.stringify(obj.body.config);
        initScript.innerHTMLToATarget('.' + obj.body.class, '');

        if (is_data_found) generateJsonToHtml(obj.body.resource, flag);
        else {
            bankStatementDefaultConfig.defaultOptions = initScript.methodWiseOption('POST', {
                // url: bankStatementDefaultConfig.widget_service_api + '/statements',
                url: getV2URL(bankStatementDefaultConfig.widget_service_api, "statements", bankStatementDefaultConfig.slugs),
                processData: false,
                data: bankStatementDefaultConfig.body,
                dataType: "json",
                headers: {
                    "Content-Type": "application/json"
                }
            }, bankStatementDefaultConfig.security_option);
            if (resource.length) getBankStatementSummary();
            if (flag && bankStatementDefaultConfig.body.transaction_id.length) getBankStatementOutlierSummaryView();
        }
    };

    const generateJsonToHtml = (resources, flag) => {
        const resource = resources[0];
        const resource_config = bankStatementDefaultConfig.body.config[resource];
        const html = TemplateServices.compileTemplate(resource_config.data, resource_config, resource, Templates.summary());
        appendBankStatementSummaryOnTable({
            data: html,
            resource: resource
        });
        // if (flag && bankStatementDefaultConfig.body.transaction_id.length) getBankStatementOutlierSummaryView();
    };

    /**
     * getBankStatementSummary : returning transactions as per requirement resource
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     */

    const getBankStatementSummary = () => {
        const options = bankStatementDefaultConfig.defaultOptions;
        options.data = JSON.stringify(options.data);
        HttpRequest(options, function (res) {
            if(!!bankStatementDefaultConfig.slugs){
                res = responseV2Interceptor(res,bankStatementDefaultConfig.slugs['statements']);
            }else{
                res = responseInterceptor(res);
            }
            // res = responseInterceptor(res);
            res = initScript.hasObjectKeyProperty(res, 'response_data') ? res.data['response_data'][bankStatementDefaultConfig['response_data_api']].data : (res.data ? res.data : res);
            // initScript.getHTMLElementByDelimiter('widgetLoader').css("display", "none");
            initScript.toggleLoader(false, true);
            appendBankStatementSummaryOnTable(res);
            promiseResolve({
                code: 200,
                status: 'success',
                data: res
            });
        });
    };

    /**
     * getTableHeadersByConfig : converting json to tr tag as per table headers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param config object
     * @param key array
     */

    const getTableHeadersByConfig = (config, key) => {
        const configKeys = Object.keys(config);
        const headers = [], others = [];
        for (let j = 0; j < configKeys.length; ++j) {
            if (config[configKeys[j]].hasOwnProperty(key)) headers[config[configKeys[j]][key] - 1] = configKeys[j];
            else others.push(configKeys[j]);
        }
        for (let i = 0; i < others.length; ++i) {
            headers.push(others[i]);
        }
        return headers;
    };

    /**
     * getJsonToTr : converting json to tr tag as per table headers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transaction object
     * @param headers object
     */

    const getJsonToTr = (transaction, headers) => {
        let html = '';
        for (let i = 0; i < headers.length; ++i) {
            html += initScript.bindAttrsOnHTMLTag('td', transaction[headers[i]]);
        }
        return initScript.bindAttrsOnHTMLTag('tr', html);
    };

    /**
     * getConsolidatedHTML : converting json to tr tag as per table headers
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactions array
     * @param config object
     * @param key string
     */

    const getConsolidatedHTML = (transactions, config, key) => {
        const headers = getTableHeadersByConfig(config, 'order');
        for (let i = 0; i < transactions.length; ++i) {
            const obj = transactions[i];
            Object.assign(obj, transactions[i]);
            obj.account_number = 'All';
            bankStatementDefaultConfig.monthly_summary_activity_data[key].push(getJsonToTr(obj, headers));
        }
    };

    /**
     * getBankStatementOutlierSummaryView : returning monthly summary transactions as per requirement resource
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const getBankStatementOutlierSummaryView = () => {
        bankStatementDefaultConfig.outlier_report_flag = true;
        bankStatementDefaultConfig.monthly_summary_activity_data = [];
        getBankStatementOutlierSummary(['account_level_monthly_activity'], function (res) {
            appendBankStatementSummaryOnTable(res);
        }, false);
        getBankStatementOutlierSummary(['consolidated_monthly_activity'], function (res) {
            const bodyConfig = bankStatementDefaultConfig.body.config;
            initScript.toggleLoader(false, true);
            const default_option = bodyConfig.account_level_monthly_activity && bodyConfig.account_level_monthly_activity.filter && bodyConfig.account_level_monthly_activity.filter.account_level && bodyConfig.account_level_monthly_activity.filter.account_level.default_option ? bodyConfig.account_level_monthly_activity.filter.account_level.default_option : 'all';
            if (res.length && !!res[0].data && res[0].data.length) {
                bankStatementDefaultConfig.monthly_summary_activity_data[default_option] = res[0].data[0];
                bankStatementDefaultConfig.monthly_summary_activity_data[default_option + '_html'] = [];
                const config = bankStatementDefaultConfig.body.config['account_level_monthly_activity'].columns;
                getConsolidatedHTML(!!res[0].data[0]['summary'] ? res[0].data[0]['summary'] : [], config, default_option + '_html');
                BankStatementOutlier.init(bankStatementDefaultConfig, bankStatementDefaultConfig.monthly_summary_activity_data[default_option]);
            }
        }, true);
        getBankStatementOutlierSummary(['account_level_monthly_activity'], function (res) {
            if (res && Array.isArray(res) && res.length && !!res[0].data && res[0].data.length) {
                for (let i = 0; i < res[0].data.length; ++i) {
                    let account_number = initScript.encryptAccountNumber(res[0].data[i]['account_number']);
                    bankStatementDefaultConfig.monthly_summary_activity_data[account_number] = res[0].data[i];
                }
            } else alert("No Data Found");
        }, true);
    };

    /**
     * getBankStatementOutlierSummary : returning transactions as per requirement resource
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource array
     * @param callback Function
     * @param flag boolean
     */

    const getBankStatementOutlierSummary = (resource, callback, flag) => {
        const options = bankStatementDefaultConfig.defaultOptions;
        options.data = bankStatementDefaultConfig.defaultOptions.data;
        if (typeof bankStatementDefaultConfig.defaultOptions.data === 'string')
            options.data = JSON.parse(options.data);
        options.data.resource = resource;
        options.data.bank_statement_end_point = 'summary';
        options.data.config[resource].json = flag;
        options.data = JSON.stringify(options.data);
        HttpRequest(options, function (res) {
            if(!!bankStatementDefaultConfig.slugs){
                res = responseV2Interceptor(res,bankStatementDefaultConfig.slugs['statements']);
            }else{
                res = responseInterceptor(res);
            }
            res = (!!res.data && !!res.data['response_data'] && !!res.data['response_data'][bankStatementDefaultConfig.response_data_api] && !!res.data['response_data'][bankStatementDefaultConfig.response_data_api].data) ? res.data['response_data'][bankStatementDefaultConfig.response_data_api].data : (!!res.data ? res.data : (!!res ? res : []));
            callback(res);
        });
    };

    /**
     * appendBankStatementSummaryOnTable : appending html on bank statement transactions on table
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resultData array
     */

    const appendBankStatementSummaryOnTable = (resultData) => {
        for (let i = 0; i < resultData.length; ++i) {
            dataTypes[resultData[i].resource] = {
                itemsPerPage: 5,
                currentPage: 1,
                paginationStartNumber: 1,
                paginationEndNumber: 4,
                rowCount: 0,
                totalNumberOfPages: 0,
                allRows: [],
                maxPaginationNumbers: 5,
                previousStartIndex: 0,
                previousEndIndex: 0,
                allPrevRows: []
            };
            createTable(resultData[i], (!!bankStatementDefaultConfig.body && !!bankStatementDefaultConfig.body.class) ? bankStatementDefaultConfig.body.class : 'widgetTable');
        }
    };


    /**
     * generateHashCodes : generating hash code for all objects
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const generateHashCodes = (resource) => {
        bankStatementDefaultConfig[resource].hash_code = {};
        for (let i = 0; i < dataTypes[resource].allPrevRows.length; ++i) {
            const child = dataTypes[resource].allPrevRows[i].children;
            let hash_code = 0;
            for (let j = 0; j < child.length; ++j) {
                hash_code += Number(initScript.hashCode(child[j].classList[0] + ':' + child[j].textContent));
            }
            bankStatementDefaultConfig[resource].hash_code[hash_code] = i;
        }
    };

    /**
     * setMapKeysWithTableRowIds : returning a map
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const setMapKeysWithTableRowIds = (resource, key) => {
        for (let i = 0; i < dataTypes[resource].allRows.length; ++i) {
            const id = dataTypes[resource].allRows[i].id;
            // bankStatementDefaultConfig
        }
    };

    /**
     * bindEventListeners : binding event listeners
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * params resource string
     */

    const bindEventListeners = (resource) => {
        initScript.getHTMLElementByDelimiter(resource + 'Pagination').on('click', 'a', function () {
            dataTypes[resource].currentPage = Number(initScript.getHTMLElementObject(this).text()) ? initScript.getHTMLElementObject(this).text() : dataTypes[resource].paginationStartNumber;
            shufflePagination(resource);
            showCurrentPageRows(resource);
            changeActivatedPage(resource, dataTypes[resource].currentPage);
        });
        initScript.getHTMLElementByDelimiter(resource + 'SelectItemsPerPage').change(function () {
            clearPagination(resource);
            dataTypes[resource].currentPage = 1;
            dataTypes[resource].itemsPerPage = initScript.getHTMLElementObject(this).children("option:selected").val();
            getTotalNumberOFPages(resource);
            setDefaultPagination(resource);
        });

        for (let i = 0; i < bankStatementDefaultConfig.exact_match_filter_options.length; ++i) {
            const obj = bankStatementDefaultConfig.exact_match_filter_options[i];
            const key = bankStatementDefaultConfig.exact_match_filter_options[i].key;
            const header_key = !!obj.header_key ? obj.header_key : key;
            initScript.getHTMLElementByDelimiter(resource + 'Select' + initScript.keyToCamelCaseWithUpperCaseString(key)).change(function () {
                const selectedVal = initScript.getHTMLElementObject(this).children("option:selected").val();
                exactlyMatchedFilter(resource, header_key, selectedVal).then(res => {
                    const mp = new Map();
                    if (selectedVal !== 'Consolidated') {
                        for (let j = 0; j < res.length; ++j) mp.set(tableRowHashCodeByIdentifier(res[j]), res[j].id);
                        bankStatementDefaultConfig.clicked_filters[resource][key] = {
                            ar: res,
                            mp: mp
                        };
                    }
                    multiTypesFilter(resource, res);
                });
            });
        }

        initScript.getHTMLElementByDelimiter(resource + 'SelectAmountLevel').change(function () {
            const selectedVal = initScript.getHTMLElementObject(this).children("option:selected").val();
            bankStatementDefaultConfig.clicked_filters[resource]['amount_level'] = amountLevelFilter(resource, 'amount', selectedVal, dataTypes[resource].sortedByAmount);
            const mp = new Map();
            const res = bankStatementDefaultConfig.clicked_filters[resource]['amount_level'];
            for (let j = 0; j < res.length; ++j) mp.set(tableRowHashCodeByIdentifier(res[j]), res[j].id);
            bankStatementDefaultConfig.clicked_filters[resource]['amount_level'] = {
                ar: res,
                mp: mp
            };
            multiTypesFilter(resource, res);
        });

        initScript.getHTMLElementByDelimiter(resource + 'SelectUnitLevel').change(function () {
            const selectedVal = initScript.getHTMLElementObject(this).children("option:selected").val();
            bankStatementDefaultConfig.clicked_filters[resource]['unit_level'] = unitLevelFilter(resource, 'amount', selectedVal);
            const mp = new Map();
            const res = bankStatementDefaultConfig.clicked_filters[resource]['unit_level'];
            for (let j = 0; j < res.length; ++j) mp.set(tableRowHashCodeByIdentifier(res[j]), res[j].id);
            bankStatementDefaultConfig.clicked_filters[resource]['unit_level'] = {
                ar: res,
                mp: mp
            };
            multiTypesFilter(resource, res);
        });
    };

    /**
     * showCurrentPageRowsUtil : displaying selected page (pagination index) number table rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const showCurrentPageRowsUtil = (resource) => {
        const currentPageRows = [];
        const tBody = initScript.getHTMLElementByDelimiter(resource + 'Table tbody');
        if (!tBody.length) return;
        initScript.removeTargetIdentifierChildren(tBody[0]);
        const currentPageStartIndex = Math.min(dataTypes[resource].rowCount, dataTypes[resource].itemsPerPage * (dataTypes[resource].currentPage - 1));
        const currentPageEndIndex = Math.min(dataTypes[resource].rowCount, dataTypes[resource].itemsPerPage * dataTypes[resource].currentPage);
        for (let i = currentPageStartIndex; i < currentPageEndIndex; ++i) {
            currentPageRows.push(dataTypes[resource].allRows[i]);
        }
        dataTypes[resource].previousStartIndex = Math.min(dataTypes[resource].rowCount, dataTypes[resource].itemsPerPage * (dataTypes[resource].currentPage - 1));
        dataTypes[resource].previousEndIndex = Math.min(dataTypes[resource].rowCount, dataTypes[resource].itemsPerPage * dataTypes[resource].currentPage);
        tBody.append(currentPageRows);
    };

    /**
     * showCurrentPageRows : displaying selected page (pagination index) number table rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const showCurrentPageRows = (resource) => {
        showCurrentPageRowsUtil(resource);
    };

    /**
     * clearPagination : removing last selected page (pagination index) table rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const clearPagination = (resource) => {
        const pagination = initScript.getHTMLElementByDelimiter(resource + 'Pagination');
        if (pagination.length > 0) pagination[0].innerHTML = '';
        // if (pagination.length > 0) initScript.removeTargetIdentifierChildren(pagination[0]);
    };

    /**
     * backPagination : changing pagination (decrementing pagination index by 1) after clicking on prev pagination tag (button)
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const backPagination = (resource) => {
        changePagination(-1, -1, resource);
        dataTypes[resource].currentPage = dataTypes[resource].paginationStartNumber;
        showCurrentPageRows(resource);
    };

    /**
     * nextPagination : changing pagination (incrementing pagination index by 1) after clicking on next pagination tag (button)
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const nextPagination = (resource) => {
        changePagination(1, 1, resource);
        dataTypes[resource].currentPage = dataTypes[resource].paginationStartNumber;
        showCurrentPageRows(resource);
    };

    /**
     * shufflePagination : shuffling pagination according to total number of pages and total selected items/page
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const shufflePagination = (resource) => {
        const resourcePagination = initScript.getHTMLElementByDelimiter(resource + 'Pagination');
        clearPagination(resource);
        const configData = bankStatementDefaultConfig.body.config;
        const paginationCSS = configData[resource] && configData[resource]['css'] && configData[resource]['css']['pagination'];
        const css = initScript.getStyleString(paginationCSS);

        if (dataTypes[resource].totalNumberOfPages >= dataTypes[resource].paginationEndNumber && dataTypes[resource].paginationStartNumber > 1) {
            initScript.getHTMLElementByDelimiter(resource + 'Pagination').append("<a href='javascript:void(0);' id='".concat(resource, "PaginationLeft'>Previous</a>"));
            initScript.getHTMLElementByDelimiter(resource + 'PaginationLeft', '#').on('click', function () {
                backPagination(resource);
            });
        }

        for (let i = dataTypes[resource].paginationStartNumber; i <= dataTypes[resource].paginationEndNumber; ++i) {
            resourcePagination.append("<a href='javascript:void(0);' style=\"".concat(css, "\" id='").concat(resource, "Page").concat(i, "' class=\"page-item\">").concat(i, "</a>"));
        }

        if (dataTypes[resource].totalNumberOfPages > dataTypes[resource].maxPaginationNumbers && dataTypes[resource].paginationEndNumber < dataTypes[resource].totalNumberOfPages) {
            resourcePagination.append("<a href='javascript:void(0);' id='".concat(resource, "PaginationRight' class=\"page-item\">Next</a>"));
            initScript.getHTMLElementByDelimiter(resource + 'PaginationRight', '#').on('click', function () {
                nextPagination(resource);
            });
        }
    };

    /**
     * changePagination : after changing selected items/page number changePagination Function will change pagination according to selected items/page number
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param start number
     * @param end number
     * @param resource string
     */

    const changePagination = (start, end, resource) => {
        if (dataTypes[resource].paginationEndNumber >= dataTypes[resource].totalNumberOfPages && start === 1) return;
        if (dataTypes[resource].paginationStartNumber === 1 && start === -1) return;
        clearPagination(resource);
        dataTypes[resource].paginationStartNumber += start;
        dataTypes[resource].paginationEndNumber += end;
        shufflePagination(resource);
        changeActivatedPage(resource, dataTypes[resource].paginationStartNumber);
    };

    /**
     * getTotalNumberOFPages : calculating total number of pages to itemsPerPage number and total number of table tr tag
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const getTotalNumberOFPages = (resource) => {
        dataTypes[resource].totalNumberOfPages = Math.ceil(dataTypes[resource].rowCount / dataTypes[resource].itemsPerPage);
    };

    /**
     * setDefaultPagination : creating a default table (itemsPerPage: 5)
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const setDefaultPagination = (resource) => {
        dataTypes[resource].paginationStartNumber = 1;
        dataTypes[resource].paginationEndNumber = dataTypes[resource].totalNumberOfPages > dataTypes[resource].maxPaginationNumbers ? dataTypes[resource].maxPaginationNumbers : dataTypes[resource].totalNumberOfPages;
        shufflePagination(resource);
        showCurrentPageRows(resource);
        changeActivatedPage(resource, dataTypes[resource].currentPage);
    };

    /**
     * changeActivatedPage : changing last active pagination index number to current
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param newPage number
     */

    const changeActivatedPage = (resource, newPage) => {
        initScript.getHTMLElementByDelimiter(resource + 'Page' + newPage, '#').addClass('active');
    };

    /**
     * extractGroupedData : returning target group data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param key string
     * @param val string
     *
     * @return data
     */

    const extractGroupedData = (resource, key, val) => {
        const data = [];
        for (let i = 0; i < dataTypes[resource].allPrevRows.length; ++i) {
            const keyText = initScript.getHTMLElementObject(dataTypes[resource].allPrevRows[i]).find('.' + key).text();
            if (keyText.toString().trim().toLowerCase() === val.toString().trim().toLowerCase()) data.push(dataTypes[resource].allPrevRows[i]);
        }
        return data.length < 1 ? dataTypes[resource].allPrevRows : data;
    };

    /**
     * getRangeIndexValues : returning array values between range i to j
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param idxI Number
     * @param idxJ Number
     *
     * @return data
     */

    const getRangeIndexValues = (resource, idxI, idxJ) => {
        const data = [];
        for (let i = idxI; i < Math.min(idxJ, dataTypes[resource].allPrevRows.length); ++i) {
            if (i >= idxI && i <= idxJ && idxI <= idxJ) data.push(dataTypes[resource].allPrevRowsSortedByAmount[i]);
        }
        return data;
    };

    /**
     * setDefaultPaginationAndCurrentPage : set default current page and table rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const setDefaultPaginationAndCurrentPage = (resource) => {
        dataTypes[resource].rowCount = dataTypes[resource].allRows.length;
        clearPagination(resource);
        dataTypes[resource].currentPage = 1;
        getTotalNumberOFPages(resource);
        setDefaultPagination(resource);
    };

    /**
     * exactlyMatchedFilter : showing selected group table rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param key string
     * @param selectedVal string
     */

    const exactlyMatchedFilter = bankStatementDefaultConfig.exactlyMatchedFilter = (resource, key, selectedVal) => {
        return new Promise((resolve, reject) => {
            if (selectedVal === 'Consolidated') dataTypes[resource].allRows = bankStatementDefaultConfig.monthly_summary_activity_data[selectedVal + '_html'];
            else dataTypes[resource].allRows = extractGroupedData(resource, key, selectedVal);
            if (bankStatementDefaultConfig.outlier_report_flag && resource === bankStatementDefaultConfig.outlier_report_resource) BankStatementOutlier.init(bankStatementDefaultConfig, bankStatementDefaultConfig.monthly_summary_activity_data[selectedVal]);
            setDefaultPaginationAndCurrentPage(resource);
            resolve(dataTypes[resource].allRows);
        })
    };

    /**
     * getRowGivenHeaderNumber : returning number
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param tdHTML string
     * @param key string
     */

    const getRowGivenHeaderNumber = (tdHTML, key) => {
        return Number($($('td', tdHTML)).closest('.' + key).text().toString().replace(/[,$]/gm, ''));
    };

    /**
     * calculateAmountArray : converting html to amount array
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param htmlAr array
     * @param key string
     */

    const calculateAmountArray = (htmlAr, key) => {
        const resp = [];
        for (let i = 0; i < htmlAr.length; ++i) {
            resp.push(getRowGivenHeaderNumber(htmlAr[i], key));
        }
        return resp;
    };

    /**
     * sortRowsByKey : sorting table rows by key
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param key string
     */

    const sortRowsByKey = (resource, key) => {
        dataTypes[resource].allPrevRows.sort(function (a, b) {
            const numA = getRowGivenHeaderNumber(a, key);
            const numB = getRowGivenHeaderNumber(b, key);
            return numA - numB;
        });
    };

    /**
     * amountLevelFilter : sort data according to amount
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param data array
     * @param resource string
     * @param key string
     * @param selectedVal object
     */

    const amountLevelFilter = bankStatementDefaultConfig.amountLevelFilter = (resource, key, selectedVal, data = []) => {
        let start = 0, end = dataTypes[resource].allPrevRows.length, val = 0;
        const rangeAr = selectedVal.split('-');
        if (rangeAr.length === 2) {
            val = initScript.convertStringToNumber(rangeAr[1]);
            if (rangeAr[0] === 'lte') end = upper_bound(data, initScript.convertStringToNumber(rangeAr[1]));
            else start = lower_bound(data, initScript.convertStringToNumber(rangeAr[1]));
        } else if (rangeAr.length === 3) {
            start = lower_bound(data, initScript.convertStringToNumber(rangeAr[1]));
            end = upper_bound(data, initScript.convertStringToNumber(rangeAr[2]));
            val = initScript.convertStringToNumber(rangeAr[2]);
        }
        if (end >= 0) end = data[end] > val ? end - 1 : end;
        dataTypes[resource].allRows = getRangeIndexValues(resource, start, end);
        setDefaultPaginationAndCurrentPage(resource);
        return dataTypes[resource].allRows;
    };

    /**
     * toggleTableHeaderCss : toggle table header css
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param tableHeaderIndex number
     * @param resource string
     */

    const toggleTableHeaderCss = (tableHeaderIndex, resource) => {
        const img_up_icon = resource + '_up_icon_' + tableHeaderIndex;
        const img_down_icon = resource + '_down_icon_' + tableHeaderIndex;
        initScript.addCSSAtTargetIdentifier(img_up_icon, {
            opacity: bankStatementDefaultConfig.sort_by_header[resource]['header_' + tableHeaderIndex].asc / 10
        });
        initScript.addCSSAtTargetIdentifier(img_down_icon, {
            opacity: bankStatementDefaultConfig.sort_by_header[resource]['header_' + tableHeaderIndex].desc / 10
        });
    };

    /**
     * sortTable : sort data according to amount
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param tableHeaderIndex number
     * @param resource string
     */

    const sortTable = (tableHeaderIndex, resource) => {
        const header = dataTypes[resource].headers[tableHeaderIndex];
        toggleTableHeaderCss(tableHeaderIndex, resource);
        sortTableUtil(tableHeaderIndex, resource, dataTypes[resource].sortByHeaders[header]).then((tableBodyTr) => {
            dataTypes[resource].sortByHeaders[header] = !dataTypes[resource].sortByHeaders[header];
            setDefaultPaginationAndCurrentPage(resource);
        });
    };

    /**
     * sortTableUtil : sort data according to amount
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param tableHeaderIndex number
     * @param resource string
     * @param toggle string
     */

    const sortTableUtil = (tableHeaderIndex, resource, toggle) => {
        return new Promise(function (resolve, reject) {
            const tBody = initScript.getHTMLElementByDelimiter(resource + 'Table tbody');

            initScript.removeTargetIdentifierChildren(tBody[0]);
            let isNumber = false;
            dataTypes[resource].allRows.sort(function (a, b) {
                const TrATdChildren = initScript.getHTMLElementObject(a).children();
                const TrBTdChildren = initScript.getHTMLElementObject(b).children();
                const x = TrATdChildren[tableHeaderIndex],
                    y = TrBTdChildren[tableHeaderIndex];
                let taskA = x.innerHTML.toLowerCase().toString().trim(),
                    taskB = y.innerHTML.toLowerCase().toString().trim();
                try {
                    if (!isNaN(initScript.convertStringToNumber(taskA)) && !isNaN(initScript.convertStringToNumber(taskB))) {
                        isNumber = true;
                        taskA = Number(initScript.convertStringToNumber(taskA));
                        taskB = Number(initScript.convertStringToNumber(taskB));
                    }
                } catch (e) {
                }
                if (!isNumber) {
                    taskA = ('' + taskA).trim();
                    taskB = ('' + taskB).trim();
                    return toggle ? taskA.localeCompare(taskB) : taskB.localeCompare(taskA);
                }
                return toggle ? (taskA - taskB) : (taskB - taskA);
            });
            resolve(dataTypes[resource].allRows);
        });
    };

    /**
     * tableRowHashCodeByIdentifier : returning target table row hash code
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param targetIdentifier string
     */

    const tableRowHashCodeByIdentifier = (targetIdentifier) => {
        if (!targetIdentifier) return 0;
        const children = targetIdentifier.children;
        let res = 0;
        for (let i = 0; i < children.length; ++i) {
            const targetTrClass = children[i].classList[0];
            res += initScript.mod(Number(initScript.hashCode(targetTrClass + '+' + children[i].textContent)));
            res = initScript.mod(res);
        }
        return res;
    };

    /**
     * multiTypesFilterUtil : sort data according to all filter types
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const multiTypesFilterUtil = (resource) => {
        return new Promise((resolve, reject) => {
            let min_length_filtered_option = '', min_length_filtered_option_length = 1e9 + 5;
            const filter = bankStatementDefaultConfig.clicked_filters[resource];
            const filterKeys = Object.keys(filter), filterValidKeys = [];
            if (!!filter['unit_level']) filterValidKeys.push('unit_level');
            if (!!filter['amount_level']) filterValidKeys.push('amount_level');
            for (let i = 0; i < filterKeys.length; ++i) {
                if (filterKeys[i] !== 'amount_level' && filterKeys[i] !== 'unit_level') filterValidKeys.push(filterKeys[i]);
                min_length_filtered_option = (min_length_filtered_option_length > filter[filterKeys[i]].ar.length) ? filterKeys[i] : min_length_filtered_option;
                min_length_filtered_option_length = Math.min(min_length_filtered_option_length, filter[filterKeys[i]].ar.length);
            }
            let res = [], count = 0;
            for (let i = 0; i < min_length_filtered_option_length; ++i) {
                const ar_val = filter[min_length_filtered_option].ar[i];
                const hash_code = tableRowHashCodeByIdentifier(ar_val);
                count = 0;
                for (let j = 0; j < filterValidKeys.length; ++j) {
                    if (filter[filterValidKeys[j]].mp.get(hash_code)) count++;
                }
                if (count === filterKeys.length) res.push(ar_val);
            }
            resolve(res);
        });
    };

    /**
     * multiTypesFilter : sort data according to all filter types
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param res string
     */

    const multiTypesFilter = (resource, res) => {
        if (!bankStatementDefaultConfig[resource].multi_filter) showCurrentPageByResult(resource, res);
        else multiTypesFilterUtil(resource).then(resp => {
                showCurrentPageByResult(resource, resp);
            });
    };

    /**
     * showCurrentPageByResult : displaying current page rows
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param res string
     */

    const showCurrentPageByResult = (resource, res) => {
        dataTypes[resource].allRows = res.length ? res : dataTypes[resource].no_record_found_td;
        setDefaultPaginationAndCurrentPage(resource);
        showCurrentPageRows(resource);
    };

    /**
     * unitLevelFilterUtil : unit level filter
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param selectedVal string
     */

    const unitLevelFilterUtil = (resource, selectedVal) => {
        const N = dataTypes[resource].allPrevRows.length;
        const n = selectedVal;
        const data = [];
        for (let i = N - 1; i >= (N - n >= 0 ? N - n : 0); --i) {
            data.push(dataTypes[resource].allPrevRows[i]);
        }
        return data;
    };

    /**
     * getHeaderSortIconsDivClass : returning header icons div class
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param headerIndex number
     */

    const getHeaderSortIconsDivClass = (resource, headerIndex) => {
        return resource + '_sort_icon_' + headerIndex;
    };

    /**
     * getHeaderSortIconClass : returning header icons class
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param headerIndex number
     * @param type string
     */

    const getHeaderSortIconClass = (resource, headerIndex, type) => {
        return resource + '_' + type + '_' + headerIndex;
    };

    /**
     * removeSortByIcons : unit level filter
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param headerIndex number
     */

    const removeSortByIcons = (resource, headerIndex) => {
        const iconsDiv = getHeaderSortIconsDivClass(resource, headerIndex);
        initScript.removeHtmlElement(iconsDiv);
    };

    /**
     * unitLevelFilter : sort data according to amount
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     * @param key string
     * @param selectedVal object
     */

    const unitLevelFilter = bankStatementDefaultConfig.unitLevelFilter = (resource, key, selectedVal) => {
        dataTypes[resource].allRows = unitLevelFilterUtil(resource, selectedVal);
        setDefaultPaginationAndCurrentPage(resource);
        return dataTypes[resource].allRows;
    };

    /**
     * bindToggleSortIconsEventListeners : binding arrow up/down icons event listeners
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param resource string
     */

    const bindToggleSortIconsEventListeners = (resource) => {
        const _loop = function _loop(i) {
            const a = bankStatementDefaultConfig.body.config;
            const header = dataTypes[resource].headers[i];

            if (!!a && !!a[resource] && !!a[resource].columns && !!a[resource].columns[header] && !!a[resource].columns[header]['sort_by_header']) {
                initScript.getHTMLElementByDelimiter(resource + '_' + dataTypes[resource].headers[i] + '_table_head').click(function (e) {
                    bankStatementDefaultConfig.sort_by_header[resource]['header_' + i].asc ^= bankStatementDefaultConfig.default_sort_by_header_config_sum;
                    bankStatementDefaultConfig.sort_by_header[resource]['header_' + i].desc ^= bankStatementDefaultConfig.default_sort_by_header_config_sum;
                    sortTable(i, resource);
                });
            }
            else removeSortByIcons(resource, i);
        };
        for (let i = 0; i < dataTypes[resource].headers.length; ++i) {
            _loop(i);
        }
    };

    /**
     * createTable : createTable function managing all functionality
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param tableObj object
     * @param widgetTableClass string
     */

    const createTable = (tableObj, widgetTableClass) => {
        if (!tableObj.data) return;
        const resource = tableObj.resource.toString().trim();
        const resource_config = bankStatementDefaultConfig.body.config;
        initScript.getHTMLElementByDelimiter(widgetTableClass).append((!!tableObj.data && tableObj.data.length) ? tableObj.data : "No Data Found");
        dataTypes[resource].allRows = dataTypes[resource].allPrevRows = initScript.getHTMLElementByDelimiter(resource + 'WidgetTable td').closest('tr');
        const headers = initScript.getHTMLElementByDelimiter(resource + 'Table thead th');
        dataTypes[resource].headers = [];
        dataTypes[resource].no_record_found = (!!resource_config && !!resource_config[resource] && !!resource_config[resource].html && !!resource_config[resource].html.no_record_found) ? resource_config[resource].html.no_record_found : 'No Record Found';
        dataTypes[resource]['sortByHeaders'] = {};
        bankStatementDefaultConfig.clicked_filters[resource] = {};
        bankStatementDefaultConfig.sort_by_header[resource] = {};
        for (let i = 0; i < headers.length; ++i) {
            const header = initScript.getHTMLElementByDelimiter(headers[i]).attr('key');
            dataTypes[resource].headers.push(header);
            dataTypes[resource].sortByHeaders[header] = false;
            bankStatementDefaultConfig.sort_by_header[resource]['header_' + i] = bankStatementDefaultConfig.default_sort_by_header_config;
        }
        dataTypes[resource].no_record_found_td = [initScript.bindAttrsOnHTMLTag('tr', initScript.bindAttrsOnHTMLTag('td', dataTypes[resource].no_record_found, {
            colspan: dataTypes[resource].headers.length,
            style: {
                'text-align': 'center'
            }
        }), {
            class: 'no_record_found'
        })];
        bankStatementDefaultConfig.default_sort_by_header_config_sum = bankStatementDefaultConfig.default_sort_by_header_config.asc ^ bankStatementDefaultConfig.default_sort_by_header_config.desc;
        dataTypes[resource].rowCount = dataTypes[resource].allRows.length;
        sortRowsByKey(resource, 'amount');
        dataTypes[resource].allPrevRowsSortedByAmount = dataTypes[resource].allPrevRows;
        dataTypes[resource].sortedByAmount = calculateAmountArray(dataTypes[resource].allPrevRows, 'amount');
        const selectItemPerPageOption = initScript.getHTMLElementByDelimiter(resource + 'SelectItemsPerPage option');
        dataTypes[resource].itemsPerPage = selectItemPerPageOption.length < 1 ? dataTypes[resource].allRows.length : selectItemPerPageOption[0].value;
        getTotalNumberOFPages(resource);
        setDefaultPagination(resource);
        bindEventListeners(resource);
        bindToggleSortIconsEventListeners(resource);
    };

    return {
        main: main,
        widgetPromise: widgetPromise
    };
}();